import LOCAL_STORAGE_KEY from "./localStorage";
import regex from './regex'


export {
    LOCAL_STORAGE_KEY,
    regex
}